if (!customElements.get("m-sharing")) {
  customElements.define(
    "m-sharing",
    class MSharing extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          shareContent: ".m-product-addon--sharing",
          openBtn: "[data-open-share]",
        };
      }

      connectedCallback() {
        this.domNodes = queryDomNodes(this.selectors, this);
        const { shareContent } = this.domNodes;
        if (shareContent && shareContent.innerHTML) {
          this.shareContent = shareContent.innerHTML;
          this.init();
        }
      }

      init() {
        this.domNodes.openBtn && this.domNodes.openBtn.classList.remove("m:hidden");
        this.modal = new MinimogTheme.Modal();
        addEventDelegate({
          selector: this.selectors.openBtn,
          handler: (e) => {
            e.preventDefault();
            if (this.shareContent) {
              const html = document.createElement("DIV");
              html.classList.add('m-sharing__content');
              html.innerHTML = this.shareContent;
              this.modal.appendChild(html);
              const colorScheme = html.querySelector('[data-color-scheme]') && html.querySelector('[data-color-scheme]').dataset.colorScheme;
              this.modal.setSizes(`m-sharing m-gradient ${colorScheme}`);
              this.modal.open();
            }
          },
        });
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tl-share-btn').forEach(function (btn) {
    btn.addEventListener('click', async function () {
      const shareUrl = btn.getAttribute('data-share-url');
      const shareTitle = btn.getAttribute('data-share-title') || document.title;

      if (navigator.share) {
        try {
          await navigator.share({
            title: shareTitle,
            url: shareUrl
          });
        } catch (e) {}
      } else {
        try {
          await navigator.clipboard.writeText(shareUrl);
          const oldHtml = btn.innerHTML;
          btn.innerHTML = '✓';
          setTimeout(function () {
            btn.innerHTML = oldHtml;
          }, 1200);
        } catch (e) {
          window.prompt('Copy this link:', shareUrl);
        }
      }
    });
  });

  document.querySelectorAll('.tl-code-chip').forEach(function (chip) {
    chip.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const code = chip.getAttribute('data-copy-code') || chip.textContent.trim();

      try {
        await navigator.clipboard.writeText(code);
        chip.classList.add('is-copied');
        const oldText = chip.textContent;
        chip.textContent = 'Copied';
        setTimeout(function () {
          chip.textContent = oldText;
          chip.classList.remove('is-copied');
        }, 1200);
      } catch (e) {
        window.prompt('Copy coupon code:', code);
      }
    });
  });

  document.querySelectorAll('.tl-offer-toggle').forEach(function (toggleBtn) {
    toggleBtn.addEventListener('click', function (e) {
      if (e.target.closest('.tl-code-chip')) return;

      const targetId = toggleBtn.getAttribute('aria-controls');
      const panel = document.getElementById(targetId);
      if (!panel) return;

      const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      panel.hidden = isExpanded;
    });

    toggleBtn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleBtn.click();
      }
    });
  });
});